// extracted by mini-css-extract-plugin
export default {"contentHeigth":"footer_contentHeigth__p2wss","backgroundColor":"footer_backgroundColor__hOpze","signedIn":"footer_signedIn__EqrKr","signedOut":"footer_signedOut__AphtN"};